import React from 'react'
import { Modal, Typography, makeStyles } from '@material-ui/core'

function getModalStyle() {
  const top = 50
  const left = 50

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`
  }
}

const useStyles = makeStyles(theme => ({
  paper: {
    position: 'absolute',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4),
    outline: 'none'
  }
}))

const SimpleModal = ({ handleClose, show, codigo, mensaje }) => {
  const [modalStyle] = React.useState(getModalStyle)
  const classes = useStyles()

  return (
    <Modal aria-labelledby='simple-modal-title' aria-describedby='simple-modal-description' open={show} onClose={handleClose}>
      <div style={modalStyle} className={classes.paper}>
        <Typography variant='h6' id='modal-title'>
          {codigo}
        </Typography>
        <Typography variant='subtitle1' id='simple-modal-description'>
          {mensaje}
        </Typography>
      </div>
    </Modal>
  )
}

export default SimpleModal
